import React from 'react'
import styled from 'styled-components'
import logo from '../img/logo.svg'
import bg from '../img/bg.jpg'
import { media, introGutter } from '../utils/style-utils'
import ScrollIndicator from './ScrollIndicator'
import { TimelineMax, Strong } from 'gsap'

const IntroWrapper = styled.section`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  padding: ${introGutter};
`

const IntroContent = styled.div`
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  padding: 3em;
  min-height: 300px;
  ${media.tablet`
    min-height: 500px;
  `};
`

const IntroLogo = styled.div`
  margin-top: 6rem;
  opacity: 0;

  img {
    display: block;
    width: 100%;
  }
  width: 180px;
  ${media.tablet`width: auto;`};
`

const IntroTitle = styled.div`
  opacity: 0;
  margin-top: 3rem;
  text-transform: uppercase;
  letter-spacing: 0.35em;
  text-align: center;
  font-size: 12px;

  ${media.tablet`
  font-size: 16px;
  `};
`

const Intro = class extends React.Component {
  componentDidMount() {
    const tl = new TimelineMax({ delay: 0.1, immediateRender: true })
    tl.fromTo(
      this.logoEl,
      1,
      { scale: 0.4, opacity: 0 },
      { scale: 1, opacity: 1, ease: Strong.easeInOut }
    )
    tl.fromTo(
      this.titleEl,
      0.7,
      { y: '1em', opacity: 0 },
      { y: 0, opacity: 1, ease: Strong.easeInOut },
      0.4
    )
  }
  render() {
    const { props } = this
    const { sitename, labels } = this.props

    return (
      <IntroWrapper>
        <IntroContent>
          <IntroLogo innerRef={logo => (this.logoEl = logo)}>
            <img src={logo} alt={sitename} />
          </IntroLogo>
          <IntroTitle innerRef={title => (this.titleEl = title)}>
            {labels.strings.baseline}
          </IntroTitle>
          <IntroTitle />
        </IntroContent>
        <ScrollIndicator label={labels.strings.scroll_label} button="true" />
        <ScrollIndicator label={labels.strings.scroll_label} />
      </IntroWrapper>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/components/Intro.js